// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "ee405a9a1-dirty",
    "hash": "ee405a9a1",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "ee405a9a1-dirty",
    "semverString": null,
    "version": "0.0.0",
    "buildDate": "11/5/2026",
    "buildTime": "Thu, 05 Nov 2026 03:42:32 GMT"
};
/* eslint:enable */
